import * as React from "react";

const Button = ({ disabled, loading, children }) => {
    return (
        <button
            className="relative min-w-none inline-flex items-center justify-center whitespace-nowrap rounded-[5px] text-base font-bold leading-[18px] border border-transparent transition-colors active:ring-4 disabled:opacity-25 disabled:cursor-not-allowed bg-brand-secondary text-brand-white border-brand-secondary hover:bg-brand-secondary-darken active:bg-brand-secondary-darken active:ring-brand-secondary-darken/40 h-[50px] px-[30px]"
            disabled={disabled || loading}
        >
            <span>{children}</span>
        </button>
    );
};

Button.displayName = "Button";

export { Button };
